<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Draft Press Release</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="modal-body-content">
                            <div class="form-field mb-3" v-if="copifyJobs">
                                <select v-model="selectedCopifyJob">
                                    <option :value="null">-- Copify Jobs --</option>
                                    <option v-for="job in copifyJobs" :value="job">{{
                                            getTitleForCopifyJob(job)
                                        }}
                                    </option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <label class="block text-gray-800 text-sm mb-2">Headline</label>
                                <input type="text"
                                       v-model="release.headline"
                                       name="headline"
                                       class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                                />
                            </div>

                            <div class="mb-3">
                                <label class="block text-gray-800 text-sm mb-2">Body</label>
                                <textarea v-model="release.body"
                                          name="body"
                                          rows="10"
                                          class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline pr-body"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-primary" type="button" @click="saveForm">Send</button>
                        <button class="btn-tertiary muted" type="button" @click="closeView">Cancel</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "DraftPressRelease",
    data() {
        return {
            release: {
                headline: null,
                body: null
            },
            copifyJobs: {},
            selectedCopifyJob: null,
            statusList: [],
        }
    },
    mounted() {
        this.setMetaTitle('Draft Press Release | JournoLink Control')
        this.loadData()
    },
    beforeDestroy() {
        //
    },
    methods: {
        /**
         * Load initial data
         *
         * @return {void}
         */
        loadData() {
            axios.all([this.getCopifyJobs(), this.getStatuses()])
                .then(axios.spread((responseJobs, responseStatus) => {
                    this.copifyJobs = _.filter(responseJobs.data, item => item.copy !== null)
                    this.statusList = responseStatus.data
                }))
        },
        /**
         * Retrieve a list of statuses from Copify.
         *
         * @return {Promise}
         */
        getStatuses() {
            return axios.get(route('professionalWriting.copify.statuses'))
        },
        /**
         * Retrieve the list of latest jobs from Copify
         *
         * @return {Object}
         */
        getCopifyJobs() {
            return axios.get(route('professionalWriting.copify.jobs'))
        },
        /**
         * Retrieve the status text for the given job
         *
         * @param job
         * @return {*|string}
         */
        getStatusForJob(job) {
            let status = this.statusList.find(item => parseInt(item.id) === parseInt(job.job_status_id))

            return status['name'] || 'Unknown'
        },
        /**
         * Draft Press Release
         *
         * @return {void}
         */
        saveForm() {
            axios.post(route('professionalWriting.pressrelease.draft', this.$route.params.professionalWritingId), this.release)
                .then(response => {
                    this.$bus.$emit('alert.success', 'Success Sent')
                    this.$parent.loadData()
                    this.closeView()
                })
                .catch(e => {
                    this.$bus.$emit('alert.dander', 'Update Failed')
                    console.error({e})
                })
        },
        /**
         * Prepare and return the display title for a Copify job
         *
         * @param  {Object} job
         * @return {String}
         */
        getTitleForCopifyJob(job) {
            if (job.title !== null) {
                return '[' + this.getStatusForJob(job) + '] ' + job.title
            }

            return '[' + this.getStatusForJob(job) + '] ' + job.name + ' (' + job.brief.substring(0, 70) + '...)'
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        }
    },
    watch: {
        selectedCopifyJob(to, from) {
            if (to !== null) {
                this.release.headline = to.title
                this.release.body = to.copy
            }
        },
    }
}
</script>

<style lang="less">
.modal-body-content {
    flex: 1;
    padding: 15px;
}

.modal-body {
    flex: 1;
    padding: 15px;

    h2, h3 {
        text-transform: uppercase;
        font-size: 1.2em;
        letter-spacing: .08em;
        color: #34495e;
        margin-bottom: 10px;
    }
}

p.note {
    margin: 10px 0;
    font-weight: bold;
}
</style>
